<template>
  <div class="help-btn"
       @click="$store.commit('cabinet/helper/toggleHelperBlock')">
    <div class="help-btn__icon">
      <IconRoundQuestionMarkOutline/>
    </div>
    <div class="help-btn__text">{{ $t('helperBtn') }}</div>
  </div>
</template>

<script>
import IconRoundQuestionMarkOutline from "@/components/icons/IconRoundQuestionMarkOutline";

export default {
  name: "HeaderHelper",
  components: {IconRoundQuestionMarkOutline},
  i18n: {
    messages: {
      en: {
        helperBtn: 'Help'
      },
      ru: {
        helperBtn: 'Помощь'
      }
    }
  }
}
</script>

<style lang="scss">
.help-btn {
  @apply flex items-center border border-icon-active rounded mr-12 text-white
  transition duration-200 cursor-pointer;

  &__icon {
    @apply border-icon-active p-2-7;
    border-color: inherit;
  }

  &__text {
    @apply text-md font-medium hidden;
  }

  &:hover {
    @apply border-border-hover;
  }

  @media(min-width: 1200px) {
    @apply pr-6;

    &__icon {
      @apply border-r mr-6;
    }

    &__text {
      @apply block;
    }
  }
}

.--anim {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
  animation: pulse-white 1s infinite;
}

@keyframes pulse-white {
  0% {
    transform: scale(0.92);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, .7);
    @apply text-text;
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    background: rgba(255, 255, 255, 0);
    @apply border-icon-active text-white;
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    background: rgba(255, 255, 255, 0);
    @apply border-icon-active text-white;
  }
}
</style>